import React, { useState, useEffect } from "react";
import {
  Typography,
  Divider,
  Row,
  Col,
  Button,
  Upload,
  Form,
  message,
  Image,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import CustomSelect from "../../../components/CustomSelect";
import CustomizationService from "../../../services/CustomizationService";
import CateringTemplate from "./CateringTemplate";
import {
  checkResolution,
  convertFormDataToObject,
  dummyRequest,
  transformImageFileToUrlObject,
} from "../../../utils";
import TestimonialService from "../../../services/TestimonialService";
import SettingsService from "../../../services/SettingsService";

const { Dragger } = Upload;
const { Title } = Typography;

export default function Catering({ isPreview }) {
  const [customizationData, setCustomizationData] = useState({});
  const [eventsData, setEventsData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [formFieldsdata, setFormFieldsData] = useState();
  const [Featuredmenu, setFeaturedMenu]= useState()


  const [form] = Form.useForm();

  let restaurantID = localStorage.getItem("restaurantId");

  useEffect(() => {
    fetchCustomizationData();
    fetchEvents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchEvents =async()=>{
    SettingsService.getCateringEvents().then((resp)=>{
      const mapData = resp.map(item => ({id:item.id, name: item.event_type_name}))
      setEventsData(mapData);
  });
  }

  const removeNullValues = (obj) => {
    // Create a new object without null values
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => value !== null)
    );
  };
  const saveCustomizationData = async () => {
    setIsSaving(true);
    try {
      const cleanedPayload = removeNullValues(formFieldsdata);
      delete cleanedPayload?.menu_items;
      delete cleanedPayload?.menu_items;
      delete cleanedPayload?.banner_heading;
      delete cleanedPayload?.catering_event_types;
      delete cleanedPayload?.certifications;
      delete cleanedPayload?.created_at;
      delete cleanedPayload?.id;
      delete cleanedPayload?.landing_page_button_title;
      delete cleanedPayload?.our_story_description;
      delete cleanedPayload?.restaurant_id;
      delete cleanedPayload?.restaurant_special_tagline;
      delete cleanedPayload?.testimonials;
      delete cleanedPayload?.theme;
      delete cleanedPayload?.updated_at;
      delete cleanedPayload?.updated_by;
      const updatedData = {
        ...cleanedPayload,
        our_story_featured_menu: Number(Featuredmenu)
    };
    const saveBuilder =   await CustomizationService.saveCustomization(
        restaurantID,
        updatedData
      );
      if (saveBuilder)
      message.success("Update Successful");
    } catch (error) {
      setIsSaving(false);
      message.error("Update Failed");
    }
  };

  const fetchCustomizationData = async () => {
    const data = await CustomizationService.getCustomizations(restaurantID);
    setFeaturedMenu(data?.our_story_featured_menu)

    form.setFieldsValue(data);
    setCustomizationData(data);
    setFormFieldsData(data)
  };

  const handleImageChange =async(info,type)=>{
    if (info.file.status === 'done'){
        const isResolutionValid = await checkResolution(info.file.originFileObj);
        if (!isResolutionValid) 
              {
                message.error("Image resolution must be greater than 1920 X 1080");
                return;
              }
            
    const formData = new FormData();
        formData.append('file', info.file.originFileObj);
        const  data  = await TestimonialService.uploadPhoto(formData); 
        if(data){
          form.setFieldsValue({[type]: data.url})
          setFormFieldsData(form.getFieldsValue())
        }  
      }
  }

  const gandleFormValueChanges = (changedValue, allValues)=>{
    setFormFieldsData(form.getFieldsValue())
  }

  return (
    <Row
      style={{
        background: "#FFFFFF",
        padding: 16,
        borderRadius: 5,
      }}
    >
      <Col xs={24} lg={12}>
      <Form
        form={form}
        name="story"
        onFieldsChange={(_, allFields) => {
          setCustomizationData(convertFormDataToObject(allFields));
        }}
        onValuesChange={gandleFormValueChanges}

        scrollToFirstError
      >
        <div className="theme-container">
          <Row>
            <Col span={24}>
              <Title level={5} className="theme-red mb-1">
                Catering
              </Title>
              <Form.Item name="catering_event_type_ids">
                <CustomSelect
                  label="Events"
                  placeholder="Select events here"
                  mode="multiple"
                  options={eventsData}
                  fieldNames={{ value: "id", label: "name" }}
                />
              </Form.Item>
              <div className="mb-1">Upload Catering BG Image</div>

              <Form.Item name="catering_banner_image_url">
                <Dragger multiple={false} customRequest={dummyRequest}
                onChange={(info)=>handleImageChange(info,'catering_banner_image_url')}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag image file to this area to upload
                  </p>
                </Dragger>
              </Form.Item>
              {/* {typeof customizationData.catering_banner_image_url ===
                "string" && (
                <Image
                  width={200}
                  src={customizationData.catering_banner_image_url}
                />
              )} */}

              <p className="ant-upload-text mt-2" style={{ color: "#3A3A3A" }}>
                NOTE: Catering form will be auto generated.
              </p>
              <Divider />

              <div className="d-flex justify-space-around">
                <Button
                  type="primary"
                  className="custom-btn"
                  // disabled={isSaving}
                  onClick={() => saveCustomizationData()}
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
</Col>
      <Col xs={24} lg={12}>
        <CateringTemplate data={customizationData}
                  eventsData={eventsData}
        
        formFieldsdata = {formFieldsdata} />
      </Col>
    </Row>
  );
}
